(function () {
    'use strict';

    var testApp = angular
        .module('invesfleet')
        .controller('detalleMiJornadaController', detalleMiJornadaController);


    detalleMiJornadaController.$inject = [
        '$stateParams', 'genericDataService', '$rootScope', '$state',
        '$filter', '$q', '$scope', 'notificationService', 'logEmpleadosService', 'common', 'modals', 'userService'
    ];


    function detalleMiJornadaController($stateParams, genericDataService, $rootScope, $state,
        $filter, $q, $scope, notificationService, logEmpleadosService, common, modals, userService ) {

        /* PUBLIC VARIABLES */
        var vm = this;
        var id = $stateParams.id;
        var tabNumber = $stateParams.tabNumber; 
        vm.jornada = {}; 
        vm.modificaciones = [];
        vm.allowAceptar = false; 
        vm.estados = [
            'Activa', 'Finalizada', 'Aprobada', 'Aceptada', 'Rechazada'
        ];
        vm.loaded = false; 
        vm.observaciones = {list: [], add: null}; 
        vm.jornadaOrig = false; 
        vm.newEfectivas = 0; 
        vm.newDescanso = 0; 

        vm.showRechazar = showRechazar;
        vm.rechazarCallback = rechazarCallback;
        vm.formatDateToHours = formatDateToHours; 
        vm.secondsToHoursAndMinutes = secondsToHoursAndMinutes; 
        vm.aceptar = aceptar;
        vm.cancelar = cancelar; 
        vm.getSobrantes = getSobrantes; 
        vm.actualize = actualize; 
        vm.addObservacion = addObservacion; 
        vm.rechazar = rechazar;
        vm.changeToOrig = changeToOrig;
        vm.getHours = getHours;
        vm.filtrarOtras = filtrarOtras; 

        (function () {
            loadData();
        })();

        function loadData() {
            if (userService.userData.empresamaster.contrataControlHorario != true) $state.go('flota.controlHorario.activarControlHorario');

            logEmpleadosService.getMyById(id).then(function (response) {
                vm.jornada = response; 
                vm.original = vm.jornada.original;
                vm.jornada.estadoDescripcion = vm.estados[vm.jornada.estado];  
                vm.allowAceptar = vm.jornada.estado == 2 && (vm.jornada.empleado.empleadoId == userService.userData.empleadoId); 
                vm.cumpleModificaciones = vm.jornada.estado == 2 && vm.jornadaOrig == false;
                vm.modificaciones = vm.jornada.registroJornadaDetalles.filter(x => x.duracion != 0);
                parseObservaciones(vm.observaciones, vm.jornada.observaciones); 
                vm.loaded = true; 
                if (vm.jornada.estado == 2) {
                    vm.fechaIni = vm.jornada.registroJornadaDetalles[0].fechaIni;
                    calcularOriginales();
                } else {
                    vm.orEfectivas = vm.jornada.horas.efectivas;
                    vm.orDescanso = vm.jornada.horas.descanso;
                }
                vm.newInicio = vm.jornada.hInicio;
                vm.newFin = vm.jornada.hFin;
                vm.newEfectivas = vm.jornada.horas.efectivas;
                vm.newDescanso = vm.jornada.horas.descanso;
            });
            
        }

        function actualize() {
            vm.loaded = false; 
           loadData(); 
        }
        
        function calcularOriginales() {
            vm.orEfectivas = 0;
            vm.orDescanso = 0;
            for (var i = 0; i < vm.jornada.registroJornadaDetalles.length; i++) {
                if (vm.jornada.registroJornadaDetalles[i].original == true) {
                    var estado = vm.jornada.registroJornadaDetalles[i].grupoEstadoEmpleadoId;
                    if (estado == 1 || estado == 2) vm.orEfectivas += vm.jornada.registroJornadaDetalles[i].duracionOrig;
                    else if (estado == 3) vm.orDescanso += vm.jornada.registroJornadaDetalles[i].duracionOrig;
                }
            }
        }

        function getHours(num) {
            if (vm.jornadaOrig == false) {
                if (num == 0) return secondsToHoursAndMinutes(vm.newEfectivas);
                else if (num == 2) return secondsToHoursAndMinutes(vm.newDescanso);
            } else {
                if (num == 0) return secondsToHoursAndMinutes(vm.orEfectivas);
                else if (num == 2) return secondsToHoursAndMinutes(vm.orDescanso);
            }
        }

        function showRechazar() {
            modals.showModal('anadirObservacion', vm.rechazarCallback);
        }

        function rechazarCallback(observacion) {
            if(observacion != '') {
                vm.observaciones.add = observacion; 
               vm.addObservacion(vm.observaciones); 
            }
            logEmpleadosService.rechazarJornada(vm.jornada.registroJornadaId, vm.jornada.observaciones).then(function () {
                sendSAveNotification('La jornada se ha rechazado correctamente');
                cancelar();
            });
        }

       function changeToOrig() {
           vm.cumpleModificaciones = vm.jornadaOrig == true ? false : true;
       }
        
        function formatDateToHours(date) {
            if(date == null) return "--:--"; 
            return moment(date).format('HH:mm');
        }

        function rechazar() {
            vm.showRechazar()
               
        }

        function secondsToHoursAndMinutes(seconds) {
            var horas = ""; 
            if(seconds < 0) {
                horas = "-";
            }
            horas += Math.abs(Math.trunc(seconds / 3600)).toString() + " h ";
            var minutes = Math.abs(Math.round((seconds % 3600) / 60)).toString() + " min";
            return horas + minutes;

        }

        function sendSAveNotification(msg) {
            notificationService.sendAppNotification({
                message: msg,
                positionY: 'top',
                positionX: 'right',
                delay: 3000,
                type: 'info'
            });
        }

        function aceptar() {
            var lista = [];
            lista.push(vm.jornada.registroJornadaId);
            logEmpleadosService.aceptarJornadas(lista).then(function () {
                sendAprobarNotification();
                cancelar();
            });
            
        }

          function sendAprobarNotification() {
              notificationService.sendAppNotification({
                  message: 'La jornada se ha guardado y aprobado correctamente',
                  positionY: 'top',
                  positionX: 'right',
                  delay: 3000,
                  type: 'info'
              });
          }

        function cancelar() {
            $rootScope.tabManager.tabs.splice($rootScope.tabManager.tabs.findIndex(x => x.title == 'Detalle jornada'), 1);

            $state.go('flota.misfichajes', {
                'tabNumber': tabNumber
            });
        }

         function getSobrantes() {
            if (43200 < vm.jornada.horas.trabajadas) {
                vm.jornada.sobrantesContrato = vm.jornada.horas.trabajadas - 43200; 
                return vm.secondsToHoursAndMinutes(vm.jornada.sobrantesContrato);
            }
            else {
                vm.jornada.sobrantesContrato = null; 
            }
            return null; 
         }

          function parseObservaciones(obs, data) {
              if (data == null) {
                  obs.list = [];
              } else {
                  try {
                      obs.list = JSON.parse(data);
                  } catch (e) {
                      data = JSON.stringify([{
                          text: data
                      }]);
                      obs.list = JSON.parse(data);
                  }
              }
          }

          function addObservacion(obs) {
              if (!obs.add) {
                  return;
              }
              obs.list.push({
                  text: obs.add,
                  time: Date.now(),
                  author: userService.userData.name ? userService.userData.name : '' +
                      (userService.userData.surname ? ' ' + userService.userData.surname : '')
              });
              obs.add = null;

                vm.jornada.observaciones = JSON.stringify(vm.observaciones.list);
          }

           function filtrarOtras(obj) {
               if (obj.duracion == 0) return false;
               return true;
           }
    }
})();
